import { render, staticRenderFns } from "./sendFeedback.vue?vue&type=template&id=0b352b85&scoped=true"
import script from "./sendFeedback.vue?vue&type=script&lang=js"
export * from "./sendFeedback.vue?vue&type=script&lang=js"
import style0 from "./sendFeedback.vue?vue&type=style&index=0&id=0b352b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b352b85",
  null
  
)

export default component.exports